export const StyleProps1: React.CSSProperties = {
    color: "black"
}


export const StyleProps2: React.CSSProperties = {
    backgroundColor : "#ff5100",
    color: "white"
}


export const StyleProps4: React.CSSProperties = {
    backgroundColor : "#304aca",
}

export const StyleProps5: React.CSSProperties = {
    color: "white"
}

export const  StyleProps6: React.CSSProperties = {
    height: "88px"
}

export const StyleProps8: React.CSSProperties = {
    color: "white",
    marginRight: "4px"
}